import * as o from "ramda";
const p = () => ({
  makeBountyConfig: (t) => ({
    apostle: {
      postSetting: o.pathOr(
        [],
        ["bounty", "apostle", "post_setting"],
        t
      ).map((e) => ({
        currencyCode: e.currency_code,
        minPrice: e.min_price
      })),
      supportedCurrencies: o.pathOr(
        [],
        ["bounty", "apostle", "support_post_currency_code"],
        t
      )
    }
  })
});
export {
  p as default
};
//# sourceMappingURL=useMakeBountyConfig.js.map
